import { useGetCommissionWalletQuery } from '@/affiliate-dashboard/graphql';
import { Button } from '@/components/base/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/base/dialog';
import { Label } from '@/components/base/label';
import { Loading } from '@/components/base/loading';
import Section from '@/components/base/section';
import { faMoneyBillTransfer } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import { AddPayoutMethod } from '../base/payout-method';

export function BalanceCard({
  methodExists,
}: {
  methodExists: boolean;
}): JSX.Element {
  const intl = useIntl();
  const { t } = useTranslation();
  const [openNewPayoutMethod, setOpenNewPayoutMethod] = useState(false);
  function onNewPayoutMethodOpenChange(value: boolean): void {
    setOpenNewPayoutMethod(value);
  }
  const { data: commissionsWallet, loading } = useGetCommissionWalletQuery();

  return (
    <Section className="h-fit w-full" variant="secondary">
      <div className="flex w-full flex-col">
        <div className="flex items-center gap-3">
          <Label>
            <FontAwesomeIcon icon={faMoneyBillTransfer} />
          </Label>
          <span>{t('wallet.balanceCard.balance')}</span>
        </div>
        <span className="mt-2 text-4xl font-bold">
          {loading ? (
            <Loading />
          ) : (
            intl.formatNumber(commissionsWallet?.commissionWallet ?? 0, {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            })
          )}
        </span>
        <Dialog
          open={openNewPayoutMethod}
          onOpenChange={(value) => {
            onNewPayoutMethodOpenChange(value);
          }}
        >
          <DialogTrigger
            asChild
            onClick={() => {
              onNewPayoutMethodOpenChange(true);
            }}
          >
            <Button className="relative mt-8 w-full">
              <span className="relative flex">
                {methodExists
                  ? t('wallet.balanceCard.changeMethod')
                  : t('wallet.balanceCard.addMethod')}
              </span>
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-3xl gap-6">
            <AddPayoutMethod
              onClose={() => {
                onNewPayoutMethodOpenChange(false);
              }}
            />
          </DialogContent>
        </Dialog>
      </div>
    </Section>
  );
}
